import React from 'react';
import axios from 'axios';
import { Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSnackbar } from 'notistack';
export default function RolesManagementTab({ token, roles, onReload }) {
    const { enqueueSnackbar } = useSnackbar();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [editTarget, setEditTarget] = React.useState(null);
    const [roleName, setRoleName] = React.useState('');
    const [saving, setSaving] = React.useState(false);
    const [deleteTarget, setDeleteTarget] = React.useState(null);
    const openCreate = () => {
        setEditTarget(null);
        setRoleName('');
        setDialogOpen(true);
    };
    const openEdit = (role) => {
        setEditTarget(role);
        setRoleName(role.role_name);
        setDialogOpen(true);
    };
    const save = () => {
        var _a;
        if (!roleName.trim())
            return;
        setSaving(true);
        const body = { id: (_a = editTarget === null || editTarget === void 0 ? void 0 : editTarget.id) !== null && _a !== void 0 ? _a : 0, role_name: roleName.trim() };
        const request = editTarget
            ? axios.put(`/role/update/${editTarget.id}`, body, { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } })
            : axios.post('/role/create', body, { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } });
        request
            .then((response) => {
            var _a;
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.success) {
                enqueueSnackbar(editTarget ? 'Роль обновлена' : 'Роль создана', { variant: 'success', autoHideDuration: 1500 });
                setDialogOpen(false);
                onReload();
            }
            else {
                enqueueSnackbar('Не удалось сохранить роль', { variant: 'error' });
            }
        })
            .catch((err) => {
            var _a, _b;
            enqueueSnackbar(((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.detail) || 'Ошибка сохранения', { variant: 'error' });
        })
            .finally(() => setSaving(false));
    };
    const confirmDelete = () => {
        if (!deleteTarget)
            return;
        axios.delete('/role/delete', {
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            data: { items: [deleteTarget.id] }
        })
            .then((response) => {
            var _a;
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.success) {
                enqueueSnackbar('Роль удалена', { variant: 'success', autoHideDuration: 1500 });
                onReload();
            }
            else {
                enqueueSnackbar('Не удалось удалить роль', { variant: 'error' });
            }
        })
            .catch((err) => {
            var _a, _b;
            enqueueSnackbar(((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.detail) || 'Ошибка удаления — возможно, роль назначена пользователям', { variant: 'error' });
        })
            .finally(() => setDeleteTarget(null));
    };
    return (React.createElement(Box, null,
        React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", sx: { mb: 2, maxWidth: 500 } },
            React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "\u0420\u043E\u043B\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u044E\u0442, \u043A \u043A\u0430\u043A\u0438\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0430\u043C \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B \u0435\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u0443 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F."),
            React.createElement(Button, { size: "small", variant: "contained", color: "success", startIcon: React.createElement(AddIcon, { fontSize: "small" }), onClick: openCreate }, "\u041D\u043E\u0432\u0430\u044F \u0440\u043E\u043B\u044C")),
        React.createElement(Stack, { direction: "row", spacing: 1, flexWrap: "wrap", useFlexGap: true, sx: { maxWidth: 700 } }, roles.map((r) => (React.createElement(Chip, { key: r.id, label: r.role_name, onDelete: () => setDeleteTarget(r), deleteIcon: React.createElement(Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0440\u043E\u043B\u044C" },
                React.createElement(DeleteIcon, { fontSize: "small" })), icon: React.createElement(IconButton, { size: "small", onClick: () => openEdit(r), sx: { p: '2px' } },
                React.createElement(EditIcon, { sx: { fontSize: 14 } })), sx: { height: 34, fontSize: 13 } })))),
        React.createElement(Dialog, { open: dialogOpen, onClose: () => setDialogOpen(false), maxWidth: "xs", fullWidth: true },
            React.createElement(DialogTitle, null, editTarget ? 'Редактировать роль' : 'Новая роль'),
            React.createElement(DialogContent, null,
                React.createElement(TextField, { autoFocus: true, label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0440\u043E\u043B\u0438", fullWidth: true, variant: "filled", sx: { mt: 1 }, value: roleName, onChange: (e) => setRoleName(e.target.value) })),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => setDialogOpen(false), disabled: saving }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
                React.createElement(Button, { variant: "contained", onClick: save, disabled: saving || !roleName.trim() }, saving ? React.createElement(CircularProgress, { size: 16 }) : 'Сохранить'))),
        React.createElement(Dialog, { open: !!deleteTarget, onClose: () => setDeleteTarget(null) },
            React.createElement(DialogTitle, null,
                "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0440\u043E\u043B\u044C \u00AB", deleteTarget === null || deleteTarget === void 0 ? void 0 :
                deleteTarget.role_name,
                "\u00BB?"),
            React.createElement(DialogContent, null,
                React.createElement(Typography, { variant: "body2" }, "\u0415\u0441\u043B\u0438 \u0440\u043E\u043B\u044C \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0430 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u043C\u0443 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E, \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C\u0441\u044F \u043E\u0448\u0438\u0431\u043A\u043E\u0439 \u2014 \u0441\u043D\u0430\u0447\u0430\u043B\u0430 \u043F\u0435\u0440\u0435\u043D\u0430\u0437\u043D\u0430\u0447\u044C\u0442\u0435 \u0442\u0430\u043A\u0438\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043D\u0430 \u0434\u0440\u0443\u0433\u0443\u044E \u0440\u043E\u043B\u044C.")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => setDeleteTarget(null) }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
                React.createElement(Button, { color: "error", variant: "contained", onClick: confirmDelete }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")))));
}
